import { PageHeader, message, Tag, Space, Popconfirm, Tooltip } from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, TableItemDinamico, SegmentedItem } from "../../../Components/Items";
import { PlusOutlined, EditOutlined, EyeOutlined, CheckCircleOutlined, StopOutlined, FilePdfOutlined, QrcodeOutlined, UnorderedListOutlined } from "@ant-design/icons";
import TabbedDynamicTable from "../../../Components/TabbedDynamicTable";
import ModalPlantillaProceso from "./Modales/ModalPlantillaProceso";
import ModalPdfPrograma from "./Modales/ModalPdfPrograma";
import ModalQRPrograma from "./Modales/ModalQRPrograma";
import ModalVerRegistroProceso from "./Modales/ModalVerRegistroProceso";
import ReporteCalidad from "./ReporteCalidad/ReporteCalidad";
import moment from "moment"

class Calidad extends Component {
  tableProgramasRef = null;
  tableProcesosRef = null;
  tableRegistrosRef = null;

  state = {
    loading: false,
    activeTab: "programas",
    programas: [],
    totalProgramas: 0,
    procesos: [],
    totalProcesos: 0,
    registros: [],
    totalRegistros: 0,
    modalPlantillasVisible: false,
    valorPrograma: 1,
    valorProceso: 1,
    modalPdf: false,
    programaIdPdf: null,
    modalQR: false,
    programaIdQR: null,
    modalChecklist: false,
    programaIdChecklist: null,
    modalVerRegistroPdf: false,
    registroIdPdf: null,
  };

  componentDidMount() {
    const primerTab = this.primerTabDisponible();
    if (primerTab) {
      this.setState({ activeTab: primerTab });
      if (primerTab === "programas") this.consultarProgramas({});
      else if (primerTab === "procesos") this.consultarProcesos({});
      else if (primerTab === "registros") this.consultarRegistros({});
    }
  }

  primerTabDisponible() {
    if (this.props.permisoAccesoProgramas) return "programas";
    if (this.props.permisoAccesoProcesos) return "procesos";
    if (this.props.permisoAccesoRegistros) return "registros";
    if (this.props.permisoAccesoReportes) return "reportes";
    return null;
  }

  consultarProgramas(params) {
    this.setState({ loading: true });
    axios
      .post(
        "programa/listaProgramas",
        { empresaId: this.props.empresaId,  valor: this.state.valorPrograma,...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({
          programas: res.data.data || [],
          totalProgramas: res.data.totalRecords || 0,
        });
        if (res.data.success === 0) message.error(res.data.message);
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ loading: false }));
  }

  consultarProcesos(params) {
    this.setState({ loading: true });
    axios
      .post(
        "proceso/listaProcesos",
        { empresaId: this.props.empresaId, valor: this.state.valorProceso, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({
          procesos: res.data.data || [],
          totalProcesos: res.data.totalRecords || 0,
        });
        if (res.data.success === 0) message.error(res.data.message);
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ loading: false }));
  }

  consultarRegistros(params) {
    this.setState({ loading: true });
    axios
      .post(
        "programa/listaRegistrosProceso",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({
          registros: res.data.data || [],
          totalRegistros: res.data.totalRecords || 0,
        });
        if (res.data.success === 0) message.error(res.data.message);
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ loading: false }));
  }

  onTabChange(key) {
    this.setState({ activeTab: key });
    if (key === "programas")  this.consultarProgramas({});
    else if (key === "procesos")  this.consultarProcesos({});
    else if (key === "registros") this.consultarRegistros({});
    // "reportes" no requiere carga inicial, el componente se autogestiona
  }

  cambiarEstadoPrograma(programaId) {
    axios
      .post(
        "programa/cambiarEstadoPrograma",
        { empresaId: this.props.empresaId, programaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success(res.data.message);
          this.consultarProgramas({});
        } else {
          message.error(res.data.message || "Error al cambiar estado");
        }
      })
      .catch(() => message.error("Error de conexión"));
  }

  cambiarEstadoProceso(procesoId) {
    axios
      .post(
        "proceso/cambiarEstadoProceso",
        { empresaId: this.props.empresaId, procesoId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success(res.data.message);
          this.consultarProcesos({});
        } else {
          message.error(res.data.message || "Error al cambiar estado");
        }
      })
      .catch(() => message.error("Error de conexión"));
  }

  render() {
    const {
      loading, activeTab, programas, procesos, totalProgramas, totalProcesos,
      modalPlantillasVisible,
    } = this.state;

    const columnasProgramas = [
      { title: "Nombre", dataIndex: "nombre", sorter: true, filterSearch: true },
      { title: "Descripción", dataIndex: "descripcion", ellipsis: true },
      {
        title: "Fecha / Duración",
        key: "fechaDuracion",
        render: (_, record) => (
          <Space direction="vertical" size={0}>
            <span>{record.fecha ? moment(record.fecha).format("DD/MM/YYYY") : "-"}</span>
            {record.duracionEstimada
              ? <span style={{ fontSize: 11, color: "#888" }}>
                  {record.duracionEstimada} {record.duracionEstimada === 1 ? "día" : "días"}
                </span>
              : null}
          </Space>
        ),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        render: (estado) => (
          <Tag color={estado === 1 ? "green" : "red"}>
            {estado === 1 ? "Activo" : "Inactivo"}
          </Tag>
        ),
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        render: (_, record) => (
          <Space size={4}>
            <ButtonItem naranja icon={<FilePdfOutlined />} onClick={() => this.setState({ modalPdf: true, programaIdPdf: record._id })} tooltip={"Ver PDF"} />
            <ButtonItem rosa icon={<UnorderedListOutlined />} onClick={() => this.setState({ modalChecklist: true, programaIdChecklist: record._id })} tooltip={"Checklist PDF"} />
            <ButtonItem icon={<QrcodeOutlined />} onClick={() => this.setState({ modalQR: true, programaIdQR: record._id })} tooltip={"Generar QR"} />
            <ButtonItem
              size="small"
              lila
              icon={<EyeOutlined />}
              tooltip="Ver"
              onClick={() =>
                this.props.history.push("/panel/programa", {
                  id: record._id,
                  modo: "ver",
                })
              }
            />
            {this.props.permisoEditarProgramas && (
              <ButtonItem
                size="small"
                lima
                icon={<EditOutlined />}
                tooltip="Editar"
                onClick={() =>
                  this.props.history.push("/panel/programa", {
                    id: record._id,
                    modo: "editar",
                  })
                }
              />
            )}
            {record.estado === 1 ? (
              <Popconfirm
                title="¿Seguro que quieres deshabilitar este programa?"
          onConfirm={() => this.cambiarEstadoPrograma(record._id)}
          okText="Sí"
          cancelText="No"
        >
          <Tooltip
            title="Deshabilitar Programa"
            placement="top"
            overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
          >
            <ButtonItem size="small" rojo icon={<StopOutlined />} />
          </Tooltip>
        </Popconfirm>
      ) : (
        <Popconfirm
          title="¿Seguro que quieres habilitar este programa?"
          onConfirm={() => this.cambiarEstadoPrograma(record._id)}
          okText="Sí"
          cancelText="No"
        >
          <Tooltip
            title="Habilitar Programa"
            placement="top"
            overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
          >
            <ButtonItem size="small" verde icon={<CheckCircleOutlined />} />
          </Tooltip>
        </Popconfirm>
      )}
    </Space>
  ),
},
    ];

    const prioridadColors = ["default", "cyan", "green", "gold", "orange", "red"];

    const columnasProcesos = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        sorter: true,
        filterSearch: true,
        ellipsis: true,
      },
      {
        title: "Responsable",
        key: "responsable",
        render: (_, record) => {
          const r = record.responsable;
          if (!r) return "-";
          const nombre = `${r.nombre || ""} ${r.apellidoPaterno || ""}`.trim();
          return <div style={{ fontSize: 12, fontWeight: 600 }}>{nombre || "-"}</div>;
        },
      },
      {
        title: "Puntos",
        dataIndex: "cantidadPuntos",
        align: "center",
        render: (v) => <Tag color="blue">{v ?? 0}</Tag>,
      },
      {
        title: "Creado por",
        key: "creador",
        ellipsis: true,
        render: (_, record) => {
          const u = record.creador;
          if (!u) return "-";
          return `${u.nombre || ""} ${u.apellidoPaterno || ""}`.trim();
        },
      },
      {
        title: "Plantilla",
        dataIndex: "esPlantilla",
        align: "center",
        render: (val) =>
          val ? <Tag color="purple">Sí</Tag> : <Tag color="default">No</Tag>,
      },
      {
        title: "Prioridad",
        dataIndex: "prioridad",
        align: "center",
        render: (p) => (
          <Tag color={prioridadColors[p] || "default"}>{p ?? "-"}</Tag>
        ),
      },
      {
        title: "Programa",
        key: "programa",
        render: (_, record) =>
          record.programa?.nombre
            ? <Tag color="geekblue">{record.programa.nombre}</Tag>
            : null,
      },
      {
        title: "Estado",
        key: "estado",
        render: (_, record) => {
          if (record.estado === 1 && record.programaId && record.programa?.estado !== 1) {
            return <Tag color="orange">Deshab. por programa</Tag>;
          }
          return (
            <Tag color={record.estado === 1 ? "green" : "red"}>
              {record.estado === 1 ? "Activo" : "Inactivo"}
            </Tag>
          );
        },
      },
      {
        title: "Acciones",
        key: "accion",
        align: "center",
        render: (_, record) => (
          <Space size={4}>
            <ButtonItem
              size="small"
              lila
              icon={<EyeOutlined />}
              onClick={() =>
                this.props.history.push("/panel/proceso", {
                  id: record._id,
                  modo: "ver",
                })
              }
              tooltip ="Ver"
            />
            {this.props.permisoEditarProcesos && (
              <ButtonItem
                size="small"
                lima
                type="primary"
                icon={<EditOutlined />}
                onClick={() =>
                  this.props.history.push("/panel/proceso", {
                    id: record._id,
                    modo: "editar",
                  })
                }
                tooltip ="Editar"
              />
            )}
            {this.props.permisoEditarProcesos && (
              record.estado === 1 ? (
                <Popconfirm
                  title="¿Seguro que quieres deshabilitar este proceso?"
                  onConfirm={() => this.cambiarEstadoProceso(record._id)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip
                    title="Deshabilitar Proceso"
                    placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                  >
                    <ButtonItem size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="¿Seguro que quieres habilitar este proceso?"
                  onConfirm={() => this.cambiarEstadoProceso(record._id)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip
                    title="Habilitar Proceso"
                    placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                  >
                    <ButtonItem size="small" verde icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
              )
            )}
          </Space>
        ),
      },
    ];


    const resultadoColor = {
      completado:                   "green",
      completado_con_observaciones: "orange",
      rechazado:                    "red",
      pendiente:                    "default",
    };
    const resultadoLabel = {
      completado:                   "Completado",
      completado_con_observaciones: "Con obs.",
      rechazado:                    "Rechazado",
      pendiente:                    "Pendiente",
    };

    const columnasRegistros = [
      {
        title: "N°",
        dataIndex: "numero",
        align: "center",
        width: 60,
        render: (v) => v ?? "-",
      },
      {
        title: "Programa",
        key: "programa",
        render: (_, r) => r.programa?.nombre ?? "-",
        ellipsis: true,
      },
      {
        title: "Proceso",
        key: "proceso",
        render: (_, r) => r.proceso?.nombre ?? "-",
        ellipsis: true,
      },
      {
        title: "Ejecutado por",
        key: "ejecutadoPor",
        render: (_, r) => {
          const u = r.ejecutadoPor;
          if (!u) return "-";
          return `${u.nombre ?? ""} ${u.apellidoPaterno ?? ""}`.trim();
        },
      },
      {
        title: "Resultado",
        dataIndex: "resultado",
        render: (v) => (
          <Tag color={resultadoColor[v] ?? "default"}>{resultadoLabel[v] ?? v}</Tag>
        ),
      },
      {
        title: "Inicio",
        dataIndex: "fechaInicio",
        render: (v) => v ? moment(v).format("DD/MM/YY HH:mm") : "-",
      },
      {
        title: "Fin",
        dataIndex: "fechaFin",
        render: (v) => v ? moment(v).format("DD/MM/YY HH:mm") : "-",
      },
      {
        title: "Puntos",
        dataIndex: "cantidadPuntos",
        align: "center",
        render: (v) => <Tag color="blue">{v ?? 0}</Tag>,
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        render: (_, r) => (
          <ButtonItem
            size="small"
            naranja
            icon={<FilePdfOutlined />}
            tooltip="Ver PDF"
            onClick={() => this.setState({ modalVerRegistroPdf: true, registroIdPdf: r._id })}
          />
        ),
      },
    ];

    const tabs = [
      this.props.permisoAccesoProgramas && {
        key: "programas",
        label: "Programas",
        forceRender: false,
        customContent: (
          <TableItemDinamico
            loading={loading}
            columns={columnasProgramas}
            dataSource={programas}
            size="small"
            rowKey="_id"
            totalRecords={totalProgramas}
            onFetchData={(params) => this.consultarProgramas(params)}
            onRef={(ref) => (this.tableProgramasRef = ref)}
          />
        ),
      },
      this.props.permisoAccesoProcesos && {
        key: "procesos",
        label: "Procesos",
        forceRender: false,
        customContent: (
          <TableItemDinamico
            loading={loading}
            columns={columnasProcesos}
            dataSource={procesos}
            size="small"
            rowKey="_id"
            totalRecords={totalProcesos}
            onFetchData={(params) => this.consultarProcesos(params)}
            onRef={(ref) => (this.tableProcesosRef = ref)}
            rowClassName={(record, index) =>
              record.esPlantilla ? "fila-con-programa" : (index % 2 === 0 ? "zebra-gris" : "default")
            }
            estadosLeyenda={[
              { color: "#f9d5ff", label: "Plantilla", key: "plantilla" },
            ]}
          />
        ),
      },
      this.props.permisoAccesoRegistros && {
        key: "registros",
        label: "Registros",
        forceRender: false,
        customContent: (
          <TableItemDinamico
            loading={loading}
            columns={columnasRegistros}
            dataSource={this.state.registros}
            size="small"
            rowKey="_id"
            totalRecords={this.state.totalRegistros}
            onFetchData={(params) => this.consultarRegistros(params)}
            onRef={(ref) => (this.tableRegistrosRef = ref)}
          />
        ),
      },
      this.props.permisoAccesoReportes && {
        key:         "reportes",
        label:       "Reportes",
        forceRender: false,
        customContent: <ReporteCalidad embedded />,
      },
    ].filter(Boolean);

    return (
      <>
        <PageHeader
          title="Calidad"
          subTitle="Programas y Procesos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            activeTab === "programas"
              ? [
                  <span key="acciones" style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    {window.innerWidth > 1000 && (
                      <>
                        <SegmentedItem
                          options={[
                            { label: "Activo", value: 1 },
                            { label: "Deshabilitado", value: 2 },
                            { label: "Todos", value: 3 },
                          ]}
                          value={this.state.valorPrograma}
                          onChange={(value) => {
                            this.setState({ valorPrograma: value }, () => {
                              this.consultarProgramas({});
                            });
                          }}
                        />
                        <div className="header-divider" />
                      </>
                    )}
                    {this.props.permisoAgregarProgramas && (
                      <ButtonItem
                        type="primary"
                        icon={<PlusOutlined />}
                        className="botonAgregar"
                        onClick={() => this.props.history.push("/panel/programa")}
                      >
                        Agregar Programa
                      </ButtonItem>
                    )}
                  </span>,
                ]
              : activeTab === "reportes"
              ? []
              : activeTab === "procesos"
              ? [
                  <span key="acciones" style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    {window.innerWidth > 1000 && (
                      <>
                        <SegmentedItem
                          options={[
                            { label: "Activo", value: 1 },
                            { label: "Deshabilitado", value: 2 },
                            { label: "Todos", value: 3 },
                            { label: "Deshab. por su programa", value: 4 },
                          ]}
                          value={this.state.valorProceso}
                          onChange={(value) => {
                            this.setState({ valorProceso: value }, () => {
                              this.consultarProcesos({});
                            });
                          }}
                        />
                        <div className="header-divider" />
                      </>
                    )}
                    {this.props.permisoAgregarProcesos && (
                      <ButtonItem
                        icon={<EyeOutlined />}
                        onClick={() => this.setState({ modalPlantillasVisible: true })}
                        className="botonAgregar"
                        lila
                      >
                        Ver Plantillas
                      </ButtonItem>
                    )}
                    {this.props.permisoAgregarProcesos && (
                      <ButtonItem
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => this.props.history.push("/panel/proceso")}
                        className="botonAgregar"
                      >
                        Agregar Proceso
                      </ButtonItem>
                    )}
                  </span>,
                ]
              : []
          }
        />
        <div 
          style={{ 
            backgroundColor: "white",
            padding: "10px", 
            borderRadius: "8px", 
          }}
        >
          <TabbedDynamicTable
            tabs={tabs}
            defaultActiveKey={this.primerTabDisponible() || "programas"}
            onTabChange={this.onTabChange.bind(this)}
          />
        </div>

        <ModalPlantillaProceso
          visible={modalPlantillasVisible}
          onCancel={() => this.setState({ modalPlantillasVisible: false })}
          onUsar={(p) => {
            this.setState({ modalPlantillasVisible: false });
            this.props.history.push("/panel/proceso", { id: p._id, modo: "editar" });
          }}
        />
        <ModalPdfPrograma
          visible={this.state.modalPdf}
          programaId={this.state.programaIdPdf}
          onCancel={() => this.setState({ modalPdf: false, programaIdPdf: null })}
        />
        <ModalPdfPrograma
          tipo="checklist"
          visible={this.state.modalChecklist}
          programaId={this.state.programaIdChecklist}
          onCancel={() => this.setState({ modalChecklist: false, programaIdChecklist: null })}
        />
        <ModalQRPrograma
          visible={this.state.modalQR}
          programaId={this.state.programaIdQR}
          onCancel={() => this.setState({ modalQR: false, programaIdQR: null })}
        />
        <ModalVerRegistroProceso
          visible={this.state.modalVerRegistroPdf}
          registroId={this.state.registroIdPdf}
          onCancel={() => this.setState({ modalVerRegistroPdf: false, registroIdPdf: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
  permisoAccesoProgramas:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a10912a2a586012f03f5c16",
    )?.activado,
  permisoAgregarProgramas:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1091342a586012f03f5c17",
    )?.activado,
  permisoEditarProgramas:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1091452a586012f03f5c26",
    )?.activado,
  permisoAccesoProcesos:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1091522a586012f03f5c34",
    )?.activado,
  permisoAgregarProcesos:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a10915f2a586012f03f5c37",
    )?.activado,
  permisoEditarProcesos:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1091692a586012f03f5deb",
    )?.activado,
  permisoAccesoRegistros:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a10917b2a586012f03f5e06",
    )?.activado,
  permisoAccesoReportes:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1091892a586012f03f5e19",
    )?.activado,
});

export default connect(mapStateToProps)(Calidad);
